import { Formik } from 'formik';
import React from 'react';
import { validationSchema } from '../constants/validationSchema';
import useNotification from '../hooks/useNotification';
import { ApiManager } from '../services/api';
import { Grid, IconButton, Tooltip } from '@mui/material';
import { LightBlueButton, TextFieldWrapper } from '.';
import * as yup from 'yup';
import { AttachFile, Delete } from '@mui/icons-material';

const SendChat = ({
  isTitle = false,
  replyTo = '',
  replying = '',
  receiver = '',
  tender = {},
  onSuccess = () => {},
  onCancel = () => {},
}) => {
  const { successNonification, errorNonification } = useNotification();

  return (
    <div className="bg-white rounded-md px-6 py-4 shadow-xl">
      <Formik
        initialValues={{
          title: '',
          message: '',
          files: [],
        }}
        validationSchema={yup.object().shape({
          title: isTitle
            ? validationSchema.required('Title')
            : validationSchema.nullable,
          message: validationSchema.required('Message'),
        })}
        onSubmit={async (values, actions) => {
          try {
            const data = new FormData();
            replyTo && data.append('replyTo', replyTo);
            replying && data.append('replying', replying);
            data.append('title', values?.title || '');
            data.append('message', values?.message || '');
            data.append('receiver', receiver);
            data.append('tender', tender._id);
            if (Array.isArray(values.files)) {
              values.files.map((item, index) => {
                data.append(`files`, item);
              });
            }

            const res = await ApiManager.sendChat(data);
            if (res?.status === 200) {
              successNonification('Message sent');
              actions.resetForm();
              onSuccess();
            } else {
              errorNonification(res?.data?.message || 'Something went wrong.');
            }
          } catch (error) {
            console.log(error);
          }
        }}
      >
        {({
          values,
          touched,
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <Grid container spacing={1}>
            {isTitle && (
              <Grid item xs={12}>
                <div className="flex flex-col gap-2">
                  <TextFieldWrapper
                    placeholder="Title"
                    autoFocus
                    name="title"
                    variant="standard"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.title}
                    helperText={touched.title && errors.title}
                    error={!!touched.title && !!errors.title}
                  />
                </div>
              </Grid>
            )}
            <Grid item xs={12}>
              <div className="flex flex-col gap-2">
                <TextFieldWrapper
                  placeholder="Message *"
                  multiline
                  minRows={5}
                  name="message"
                  variant="standard"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.message}
                  helperText={touched.message && errors.message}
                  error={!!touched.message && !!errors.message}
                />
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="flex justify-between gap-6">
                <div className="flex-1 flex gap-2">
                  {' '}
                  {values.files.map((item, index) => {
                    return (
                      <Tooltip title={item.name} arrow placement="top">
                        <div
                          key={index + item.name}
                          className="flex items-center bg-gray-300 rounded-md pr-2"
                        >
                          <IconButton
                            size="small"
                            onClick={() => {
                              var files = values.files;
                              files.splice(index, 1);
                              setFieldValue('files', files);
                            }}
                          >
                            <Delete size="small" />
                          </IconButton>
                          <span className="max-w-10 text-xs truncate">
                            {item.name}
                          </span>
                        </div>
                      </Tooltip>
                    );
                  })}
                </div>
                <div className="flex items-center gap-2">
                  <input
                    placeholder="Placeholder"
                    hidden
                    type="file"
                    id="files"
                    multiple
                    name="files"
                    onChange={(e) => {
                      var files = [...values.files];
                      if (e.target.files && e.target.files.length > 0) {
                        for (var i = 0; i < e.target.files.length; i++) {
                          files.push(e.target.files[i]);
                        }
                      }
                      setFieldValue('files', files);
                    }}
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="flex items-center justify-between">
                <div className="flex gap-2">
                  <LightBlueButton
                    onClick={handleSubmit}
                    sx={{ letterSpacing: '2px', py: '10px' }}
                  >
                    Send
                  </LightBlueButton>

                  <label
                    className="hover:bg-gray-200 px-2 py-3 text-center text-xs text-black rounded-lg cursor-pointer"
                    htmlFor="files"
                  >
                    <AttachFile fontSize="small" />
                  </label>
                </div>

                <div
                  onClick={onCancel}
                  className="hover:bg-gray-200 px-2 py-3 text-center text-xs text-black rounded-lg cursor-pointer"
                >
                  <Delete fontSize="small" />
                </div>
              </div>
            </Grid>
          </Grid>
        )}
      </Formik>
    </div>
  );
};

export default SendChat;
